import React, { useEffect, useState, useCallback } from "react";
import {
  Card,
  ProgressBar,
  Table,
  Button,
  Row,
  Col,
  Form,
} from "react-bootstrap";
import { formatDateInTimezone } from "../../../utils/formatDateInTimezone";
import { companyID } from "../../../auth";
import {
  applyForResignationWithdrawal,
  getSalaryHoldTypes,
  resignationApproval,
} from "../../../services/ResignationServices";
import api from "../../../api/axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { differenceInDays, parseISO } from "date-fns";
import { formatDateForSQL } from "../../../utils/formatDateForSQL";
import Swal from "sweetalert2";
import Loader from "../../../components/Loader";
import DeleteModal from "../../../components/modelpopup/DeleteModal";

const ResignationDetails = ({
  employee_id,
  setAlreadyApplied,
  separationModal,
  activeTab,
}) => {
  const company_id = companyID();
  const loginEmployeeId = localStorage.getItem("employeeID");
  const [resignationDetails, setResignationDetails] = useState({});
  const [expanded, setExpanded] = useState(false);
  const [salaryHoldTypes, setSalaryHoldTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [editingField, setEditingField] = useState(null);
  const [tempValues, setTempValues] = useState({});
  const [editPremission, setEditPremission] = useState(false);
  const [loading, setLoading] = useState({
    show: false,
    message: "",
  });
  const [decisionRemarksError, setDecisionRemarksError] = useState({});
  const [decisionRemarks, setDecisionRemarks] = useState("");

  function checkApprover(resignationData) {
    if (
      !Array.isArray(resignationData?.approval_history) ||
      resignationData?.approval_history?.length === 0
    ) {
      setEditPremission(false);
    }

    const permission =
      resignationData?.approval_history?.some(
        (approval) => approval?.approved_by == loginEmployeeId
      ) &&
      parseISO(resignationData?.last_working_date)?.setHours(0, 0, 0, 0) >=
        new Date()?.setHours(0, 0, 0, 0);

    setEditPremission(permission);
  }

  const truncateText = (text, wordLimit) => {
    if (!text) return "";
    const words = text.trim().split(/\s+/);
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(" ") + "...";
    }
    return text;
  };

  const fetchResignationDetails = useCallback(
    async (company_id, employee_id) => {
      setIsLoading(true);
      try {
        const res = await api.get(
          `employees-resignations/${company_id}?employee_id=${employee_id}`
        );
        const data =
          res?.data?.result?.filter(
            (resignation) => resignation?.resignation_status !== 3
          )[0] || {};
        checkApprover(data, employee_id);
        setResignationDetails(data);
        if (
          data.approval_history?.[0]?.approval_status === 1 ||
          data.approval_history?.[0]?.approval_status === 2
        ) {
          setAlreadyApplied(true);
        }
      } catch (err) {
        setError(err.message);
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    },
    [setAlreadyApplied]
  );

  const fetchSalaryHoldTypes = async () => {
    try {
      const response = await getSalaryHoldTypes();
      setSalaryHoldTypes(response.result || []);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (company_id && employee_id) {
      fetchResignationDetails(company_id, employee_id);
    }
    fetchSalaryHoldTypes();
  }, [company_id, employee_id, separationModal, fetchResignationDetails]);

  const startEditing = (field, initialValue) => {
    setEditingField(field);
    setTempValues({ ...tempValues, [field]: initialValue });
  };

  const cancelEditing = () => {
    setEditingField(null);
    setTempValues({});
    setDecisionRemarksError({});
    setDecisionRemarks("");
  };

  function isDateLessThanCurrent(dateStr) {
  const givenDate = new Date(dateStr);   // input date
  const currentDate = new Date();        // today's date

  // remove time part for correct comparison
  givenDate.setHours(0, 0, 0, 0);
  currentDate.setHours(0, 0, 0, 0);

  return givenDate < currentDate;
}
  const adjustDate = (date, days) => {
      let newDate = new Date(date);
      newDate.setDate(newDate.getDate() + days);
      return newDate.toISOString().split("T")[0];
    };

  const saveChanges = async (field) => {
    try {
      const value = tempValues[field];
      let payload = {};
      let updatedDetails = { ...resignationDetails };
      const separationDate = parseISO(resignationDetails.resignation_date);
        const newLastWorkingDate =
          value instanceof Date ? value : parseISO(value);

      if (field === "last_working_date") {
        console.log("resignationDetails" , resignationDetails);
        
        if (newLastWorkingDate < separationDate) {
          Swal.fire({
            title: "Separation",
            text: "Last Working Day cannot be before Separation Date",
            icon: "warning",
            confirmButtonText: "OK",
            timer: 2000,
            timerProgressBar: true,
            customClass: {
              confirmButton: "btn btn-warning",
            },
          });
          return;
        }
        const noticePeriodDays = differenceInDays(
          newLastWorkingDate,
          separationDate
        );
        payload = {
          last_working_date: formatDateForSQL(newLastWorkingDate.toISOString()),
          notice_period_days: noticePeriodDays,
           salary_release_date : adjustDate(newLastWorkingDate.toISOString(), resignationDetails?.salary_release_days),
        asset_return_due_date : formatDateForSQL(newLastWorkingDate.toISOString()),
        pending_amount_release_date : adjustDate(newLastWorkingDate.toISOString(), resignationDetails?.salary_release_days),
        document_release_date : adjustDate(newLastWorkingDate.toISOString(), resignationDetails?.salary_release_days) ,
        resignation_status : resignationDetails?.resignation_status,
        current_resignation_status :  isDateLessThanCurrent(formatDateForSQL(newLastWorkingDate.toISOString())) ? 3: 2
        };
        updatedDetails = {
          ...updatedDetails,
          last_working_date: newLastWorkingDate.toISOString(),
          notice_period_days: noticePeriodDays,
           salary_release_date : adjustDate(newLastWorkingDate.toISOString(), resignationDetails?.salary_release_days),
        asset_return_due_date : formatDateForSQL(newLastWorkingDate.toISOString()),
        pending_amount_release_date : adjustDate(newLastWorkingDate.toISOString(), resignationDetails?.salary_release_days),
        document_release_date : adjustDate(newLastWorkingDate.toISOString(), resignationDetails?.salary_release_days) ,
        resignation_status : resignationDetails?.resignation_status,
          

        };
      } else if (field === "salary_hold_type_id") {
        if (!value) {
          Swal.fire({
            title: "Separation",
            text: "Please select a valid salary hold type",
            icon: "warning",
            confirmButtonText: "OK",
            timer: 2000,
            timerProgressBar: true,
            customClass: {
              confirmButton: "btn btn-warning",
            },
          });
          return;
        }
        payload = { salary_hold_type_id: parseInt(value) };
        updatedDetails = {
          ...updatedDetails,
          salary_hold_type_id: parseInt(value),
        };
      } else {
        const newDate = value instanceof Date ? value : parseISO(value);
        if (newDate < new Date()) {
          Swal.fire({
            title: "Separation",
            text: `${field.replace(/_/g, " ")} cannot be in the past`,
            icon: "warning",
            confirmButtonText: "OK",
            timer: 2000,
            timerProgressBar: true,
            customClass: {
              confirmButton: "btn btn-warning",
            },
          });
          return;
        }
        payload = { [field]: formatDateForSQL(newDate.toISOString()) };
        updatedDetails = { ...updatedDetails, [field]: newDate.toISOString() };
      }
      console.log("payload" , payload);
      await api.put(
        `update-resignation-details/${resignationDetails?.employees_resignations_id}/${loginEmployeeId}`,
        {
          ...payload,
          separatedEmployee: resignationDetails?.employee_id,
          current_resignation_status: isDateLessThanCurrent(formatDateForSQL(newLastWorkingDate.toISOString())) ? 3: 2,
        }
      );
      setResignationDetails(updatedDetails);
      setEditingField(null);
      setTempValues({});
      Swal.fire({
        title: "Separation",
        text: "Update successful",
        icon: "success",
        confirmButtonText: "OK",
        timer: 2000,
        timerProgressBar: true,
        customClass: {
          confirmButton: "btn btn-primary",
        },
      });
    } catch (err) {
      Swal.fire({
        title: "Separation",
        text: "Something went wrong, Please try again later",
        icon: "warning",
        confirmButtonText: "OK",
        timer: 2000,
        timerProgressBar: true,
        customClass: {
          confirmButton: "btn btn-warning",
        },
      });
      console.error(err);
    }
  };

  if (isLoading)
    return <div className="tab-pane fade text-center">Loading...</div>;
  if (error)
    return (
      <div className="tab-pane fade text-center">
        Oops, Something went wrong !
      </div>
    );
  if (!resignationDetails?.resignation_date) {
    return (
      <div className="tab-pane fade text-center" id="emp_resignation">
        No Separation data!
      </div>
    );
  }

  const approvalStatus =
    resignationDetails?.approval_history?.[0]?.approval_status;
  const statusText =
    approvalStatus === 1
      ? "Pending"
      : approvalStatus === 2
      ? "Approved"
      : approvalStatus === 3
      ? "Rejected"
      : "Unknown";

  const submitResignationApproval = async (approvalId, approvalData) => {
    setLoading((prev) => ({
      ...prev,
      show: true,
      message: `${
        approvalData?.approval_status == 2 ? "Approving" : "Rejecting"
      } separation...`,
    }));
    try {
      await resignationApproval(approvalId, approvalData);
      setDecisionRemarksError({});
      setDecisionRemarks("");
      setEditingField(null);
      setTempValues({});
      await fetchResignationDetails(company_id, employee_id);
      Swal.fire({
        title: "Separation",
        text: `Separation ${
          approvalData?.approval_status == 2 ? "approved" : "rejected"
        }`,
        icon: "success",
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Separation",
        text: "Something went wrong, please try again later !",
        icon: "warning",
        confirmButtonText: "OK",
        timer: 2000,
        timerProgressBar: true,
        customClass: {
          confirmButton: "btn btn-primary",
        },
      });
    } finally {
      setLoading((prev) => ({
        ...prev,
        show: false,
        message: "",
      }));
    }
  };

  const approvalAction = async (action, record) => {
    try {
      const approvalData = {
        resignation_date: formatDateInTimezone(record?.resignation_date),
        last_working_date: formatDateInTimezone(record?.last_working_date),
        requestor_id: record?.employee_id,
        employees_resignations_id: record?.employees_resignations_id,
        approval_status: action,
        employee_id: loginEmployeeId,
      };
      if (!decisionRemarks) {
        setDecisionRemarksError((prev) => ({
          ...prev,
          decisionRemarks: "Please give a valid decision Remarks.",
        }));
        return;
      } else if (decisionRemarks.length < 5) {
        setDecisionRemarksError((prev) => ({
          ...prev,
          decisionRemarks: "Please write more for decision Remarks.",
        }));
        return;
      }
      await submitResignationApproval(
        record?.approval_history[0]?.approval_id,
        { ...approvalData, remarks: decisionRemarks }
      );
    } catch (error) {
      console.error(error);
    }
  };

  const withdrawSeparation = async () => {
    try {
      setLoading((prev) => ({
        ...prev,
        show: true,
        message: "Withdrawing separation...",
      }));

      const response = await applyForResignationWithdrawal(
        resignationDetails?.employees_resignations_id,
        loginEmployeeId
      );
      if (response?.success) {
        Swal.fire({
          title: "Separation",
          text: "Separation withdrawal successful",
          icon: "success",
          confirmButtonText: "OK",
          timer: 2000,
          timerProgressBar: true,
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
        setAlreadyApplied(false);
        await fetchResignationDetails(company_id, employee_id);
      } else {
        Swal.fire({
          title: "Separation",
          text: response?.message || "Failed to withdraw separation",
          icon: "warning",
          confirmButtonText: "OK",
          timer: 2000,
          timerProgressBar: true,
          customClass: {
            confirmButton: "btn btn-danger",
          },
        });
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Separation",
        text: "Something went wrong, please try again later !",
        icon: "warning",
        confirmButtonText: "OK",
        timer: 2000,
        timerProgressBar: true,
        customClass: {
          confirmButton: "btn btn-danger",
        },
      });
    } finally {
      setLoading((prev) => ({
        ...prev,
        show: false,
        message: "",
      }));
    }
  };

  return (
    <div
      className={`tab-pane fade ${
        activeTab === "emp_resignation" ? "show active" : ""
      }`}
      id="emp_resignation"
    >
      <Row className="mb-4">
        <Col md={6} className="mb-4">
          <Card className="h-100 shadow-sm overflow-scroll">
            <Card.Body>
              <Card.Title>Separation Details</Card.Title>
              <div className="d-flex justify-content-between flex-row-reverse mb-2">
                {Number(loginEmployeeId) === resignationDetails?.employee_id &&
                  approvalStatus === 1 && (
                    <Button
                      data-bs-toggle="modal"
                      data-bs-target="#delete_employee"
                      variant="outline-warning"
                      size="sm"
                      className="float-end"
                    >
                      Withdrawl separation
                    </Button>
                  )}
              </div>
              <Table borderless responsive>
                <tbody>
                  <tr>
                    <td>
                      <strong>Separation Date:</strong>
                    </td>
                    <td>
                      {formatDateInTimezone(
                        resignationDetails.resignation_date
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Last Working Day:</strong>
                    </td>
                    <td>
                      {editingField === "last_working_date" ? (
                        <div
                          className="d-flex align-items-center gap-2"
                          style={{ width: "max-content" }}
                        >
                          <DatePicker
                            selected={
                              tempValues.last_working_date ||
                              parseISO(resignationDetails.last_working_date)
                            }
                            onChange={(date) =>
                              setTempValues({
                                ...tempValues,
                                last_working_date: date,
                              })
                            }
                            dateFormat="yyyy-MM-dd"
                            className="form-control"
                            minDate={
                              new Date(resignationDetails.resignation_date)
                            }
                          />
                          <Button
                            variant="outline-success"
                            size="sm"
                            onClick={() => saveChanges("last_working_date")}
                          >
                            Save
                          </Button>
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={cancelEditing}
                          >
                            Cancel
                          </Button>
                        </div>
                      ) : (
                        <>
                          {formatDateInTimezone(
                            resignationDetails.last_working_date
                          )}
                          {editPremission && (
                            <i
                              className="btn fa-regular fa-pen-to-square text-info ms-2"
                              onClick={() =>
                                startEditing(
                                  "last_working_date",
                                  parseISO(resignationDetails.last_working_date)
                                )
                              }
                            />
                          )}
                        </>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Notice Period:</strong>
                    </td>
                    <td>{resignationDetails.notice_period_days} Days</td>
                  </tr>
                  <tr>
                    <td colSpan="2">
                      <strong>Separation Reason:</strong>
                      <p
                        colSpan="2"
                        style={{
                          width: "auto",
                          whiteSpace: "normal",
                          verticalAlign: "top",
                        }}
                      >
                        {expanded
                          ? resignationDetails.reason_of_resignation
                          : truncateText(
                              resignationDetails.reason_of_resignation,
                              20
                            )}
                        {resignationDetails.reason_of_resignation?.split(/\s+/)
                          .length > 20 && (
                          <button
                            className="btn btn-link text-primary"
                            onClick={() => setExpanded(!expanded)}
                            style={{ paddingTop: "0px", fontSize: "14px" }}
                          >
                            {expanded ? "Read Less" : "Read More"}
                          </button>
                        )}
                      </p>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6} className="mb-4">
          <Card className="h-100 shadow-sm overflow-scroll">
            <Card.Body>
              <Card.Title>Separation Status Timeline</Card.Title>
              <ProgressBar className="mb-3">
                <ProgressBar
                  variant="success"
                  now={33.33}
                  label="Submitted"
                  key={1}
                />
                <ProgressBar
                  variant={approvalStatus >= 2 ? "success" : "warning"}
                  now={approvalStatus >= 2 ? 33.33 : 0}
                  label="Reporter Approval"
                  key={2}
                />
                <ProgressBar
                  variant={
                    approvalStatus === 2
                      ? "success"
                      : approvalStatus === 3
                      ? "danger"
                      : "warning"
                  }
                  now={approvalStatus >= 2 ? 33.33 : 0}
                  label="Final Status"
                  key={3}
                />
              </ProgressBar>
              <Table borderless>
                <tbody>
                  <tr>
                    <td>
                      <strong>Submitted:</strong>
                    </td>
                    <td>
                      {formatDateInTimezone(
                        resignationDetails.resignation_date
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Final Status:</strong>
                    </td>
                    <td>
                      <span
                        className={`text-white badge bg-${
                          approvalStatus === 2
                            ? "success"
                            : approvalStatus === 3
                            ? "danger"
                            : "warning"
                        } p-1 fs-14`}
                      >
                        {statusText}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Final Remark:</strong>
                    </td>
                    <td>{resignationDetails?.remarks || "-"}</td>
                  </tr>
                  {resignationDetails.approval_history?.[0]?.approved_by &&
                    editingField === "approval_status" && (
                      <tr>
                        <td colSpan="2">
                          <strong>Decision Remarks:</strong>
                          <textarea
                            colSpan="2"
                            className="form-control"
                            placeholder="Enter Decision Remarks"
                            value={decisionRemarks}
                            onChange={(e) => {
                              setDecisionRemarks(e.target.value);
                              setDecisionRemarksError((prev) => ({
                                ...prev,
                                decisionRemarks: "",
                              }));
                            }}
                          />
                          {decisionRemarksError?.decisionRemarks && (
                            <span className="text-danger">
                              * {decisionRemarksError?.decisionRemarks}
                            </span>
                          )}
                        </td>
                      </tr>
                    )}
                  <tr>
                    <td>
                      <strong>Reporter Approval:</strong>
                    </td>
                    {resignationDetails.approval_history?.[0]?.approved_by &&
                    editingField === "approval_status" ? (
                      <td>
                        <div
                          className="d-flex align-items-center gap-2"
                          style={{ width: "max-content" }}
                        >
                          {editPremission && (
                            <Form.Select
                              className="w-auto"
                              value={approvalStatus}
                              onChange={(e) =>
                                approvalAction(
                                  parseInt(e.target.value),
                                  resignationDetails
                                )
                              }
                            >
                              <option value="">Select Action</option>
                              <option value={2}>Approve</option>
                              <option value={3}>Reject</option>
                            </Form.Select>
                          )}

                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={cancelEditing}
                          >
                            Cancel
                          </Button>
                        </div>
                      </td>
                    ) : (
                      <td>
                        <span
                          className={`text-white badge bg-${
                            approvalStatus === 2
                              ? "success"
                              : approvalStatus === 3
                              ? "danger"
                              : "warning"
                          } p-1 fs-14`}
                        >
                          {statusText}
                        </span>
                        {editPremission && (
                          <i
                            className="btn fa-regular fa-pen-to-square text-info ms-2"
                            onClick={() =>
                              startEditing(
                                "approval_status",
                                resignationDetails.approval_history?.[0]
                                  ?.approval_status
                              )
                            }
                          />
                        )}
                      </td>
                    )}
                  </tr>
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col md={6} className="mb-4">
          <Card className="h-100 shadow-sm overflow-scroll">
            <Card.Body>
              <Card.Title>Important Dates & Information</Card.Title>
              <Table borderless>
                <tbody>
                  <tr>
                    <td>
                      <strong>Salary on Hold:</strong>
                    </td>
                    <td>
                      {editingField === "salary_hold_type_id" ? (
                        <div
                          className="d-flex align-items-center gap-2"
                          style={{ width: "max-content" }}
                        >
                          <Form.Select
                            value={tempValues.salary_hold_type_id || ""}
                            onChange={(e) =>
                              setTempValues({
                                ...tempValues,
                                salary_hold_type_id: e.target.value,
                              })
                            }
                          >
                            <option value="">Select Type</option>
                            {salaryHoldTypes.map((type) => (
                              <option key={type.id} value={type.id}>
                                {type.name}
                              </option>
                            ))}
                          </Form.Select>
                          <Button
                            variant="outline-success"
                            size="sm"
                            onClick={() => saveChanges("salary_hold_type_id")}
                            disabled={!tempValues.salary_hold_type_id}
                          >
                            Save
                          </Button>
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={cancelEditing}
                          >
                            Cancel
                          </Button>
                        </div>
                      ) : (
                        <>
                          {salaryHoldTypes.find(
                            (type) =>
                              type.id === resignationDetails.salary_hold_type_id
                          )?.name || "N/A"}
                          {editPremission && (
                            <i
                              className="btn fa-regular fa-pen-to-square text-info ms-2"
                              onClick={() =>
                                startEditing(
                                  "salary_hold_type_id",
                                  resignationDetails.salary_hold_type_id
                                )
                              }
                            />
                          )}
                        </>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Salary Release Date:</strong>
                    </td>
                    <td>
                      {editingField === "salary_release_date" ? (
                        <div
                          className="d-flex align-items-center gap-2"
                          style={{ width: "max-content" }}
                        >
                          <DatePicker
                            selected={
                              tempValues.salary_release_date ||
                              parseISO(resignationDetails.salary_release_date)
                            }
                            onChange={(date) =>
                              setTempValues({
                                ...tempValues,
                                salary_release_date: date,
                              })
                            }
                            dateFormat="yyyy-MM-dd"
                            className="form-control"
                            minDate={
                              new Date(resignationDetails.resignation_date)
                            }
                          />
                          <Button
                            variant="outline-success"
                            size="sm"
                            onClick={() => saveChanges("salary_release_date")}
                          >
                            Save
                          </Button>
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={cancelEditing}
                          >
                            Cancel
                          </Button>
                        </div>
                      ) : (
                        <>
                          {formatDateInTimezone(
                            resignationDetails.salary_release_date
                          )}
                          {editPremission && (
                            <i
                              className="btn fa-regular fa-pen-to-square text-info ms-2"
                              onClick={() =>
                                startEditing(
                                  "salary_release_date",
                                  parseISO(
                                    resignationDetails.salary_release_date
                                  )
                                )
                              }
                            />
                          )}
                        </>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Pending Amount Release:</strong>
                    </td>
                    <td>
                      {editingField === "pending_amount_release_date" ? (
                        <div
                          className="d-flex align-items-center gap-2"
                          style={{ width: "max-content" }}
                        >
                          <DatePicker
                            selected={
                              tempValues.pending_amount_release_date ||
                              parseISO(
                                resignationDetails.pending_amount_release_date
                              )
                            }
                            onChange={(date) =>
                              setTempValues({
                                ...tempValues,
                                pending_amount_release_date: date,
                              })
                            }
                            dateFormat="yyyy-MM-dd"
                            className="form-control"
                            minDate={
                              new Date(resignationDetails.resignation_date)
                            }
                          />
                          <Button
                            variant="outline-success"
                            size="sm"
                            onClick={() =>
                              saveChanges("pending_amount_release_date")
                            }
                          >
                            Save
                          </Button>
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={cancelEditing}
                          >
                            Cancel
                          </Button>
                        </div>
                      ) : (
                        <>
                          {formatDateInTimezone(
                            resignationDetails.pending_amount_release_date
                          )}
                          {editPremission && (
                            <i
                              className="btn fa-regular fa-pen-to-square text-info ms-2"
                              onClick={() =>
                                startEditing(
                                  "pending_amount_release_date",
                                  parseISO(
                                    resignationDetails.pending_amount_release_date
                                  )
                                )
                              }
                            />
                          )}
                        </>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Document Release:</strong>
                    </td>
                    <td>
                      {editingField === "document_release_date" ? (
                        <div
                          className="d-flex align-items-center gap-2"
                          style={{ width: "max-content" }}
                        >
                          <DatePicker
                            selected={
                              tempValues.document_release_date ||
                              parseISO(resignationDetails.document_release_date)
                            }
                            onChange={(date) =>
                              setTempValues({
                                ...tempValues,
                                document_release_date: date,
                              })
                            }
                            dateFormat="yyyy-MM-dd"
                            className="form-control"
                            minDate={
                              new Date(resignationDetails.resignation_date)
                            }
                          />
                          <Button
                            variant="outline-success"
                            size="sm"
                            onClick={() => saveChanges("document_release_date")}
                          >
                            Save
                          </Button>
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={cancelEditing}
                          >
                            Cancel
                          </Button>
                        </div>
                      ) : (
                        <>
                          {formatDateInTimezone(
                            resignationDetails.document_release_date
                          )}
                          {editPremission && (
                            <i
                              className="btn fa-regular fa-pen-to-square text-info ms-2"
                              onClick={() =>
                                startEditing(
                                  "document_release_date",
                                  parseISO(
                                    resignationDetails.document_release_date
                                  )
                                )
                              }
                            />
                          )}
                        </>
                      )}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6} className="mb-4">
          <Card className="h-100 shadow-sm overflow-scroll">
            <Card.Body>
              <Card.Title>Asset Return Details</Card.Title>
              <Table borderless>
                <tbody>
                  <tr>
                    <td>
                      <strong>Asset return status:</strong>
                    </td>
                    <td>{resignationDetails.asset_return_status}</td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Asset return due date:</strong>
                    </td>
                    <td>
                      {editingField === "asset_return_due_date" ? (
                        <div
                          className="d-flex align-items-center gap-2"
                          style={{ width: "max-content" }}
                        >
                          <DatePicker
                            selected={
                              tempValues.asset_return_due_date ||
                              parseISO(resignationDetails.asset_return_due_date)
                            }
                            onChange={(date) =>
                              setTempValues({
                                ...tempValues,
                                asset_return_due_date: date,
                              })
                            }
                            dateFormat="yyyy-MM-dd"
                            className="form-control"
                            minDate={
                              new Date(resignationDetails.resignation_date)
                            }
                          />
                          <Button
                            variant="outline-success"
                            size="sm"
                            onClick={() => saveChanges("asset_return_due_date")}
                          >
                            Save
                          </Button>
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={cancelEditing}
                          >
                            Cancel
                          </Button>
                        </div>
                      ) : (
                        <>
                          {formatDateInTimezone(
                            resignationDetails.asset_return_due_date
                          )}
                          {editPremission && (
                            <i
                              className="btn fa-regular fa-pen-to-square text-info ms-2"
                              onClick={() =>
                                startEditing(
                                  "asset_return_due_date",
                                  parseISO(
                                    resignationDetails.asset_return_due_date
                                  )
                                )
                              }
                            />
                          )}
                        </>
                      )}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Loader show={loading.show} loadingMessage={loading.message} />
      <DeleteModal
        Name="Withdraw Separation"
        confirmDelete={withdrawSeparation}
        btnName={"Withdraw"}
      />
    </div>
  );
};

export default ResignationDetails;
